import { Breadcrumbs } from "../../Home/Breadcrumb"
import { BuscarEmpresaSupervisora } from "./Buscar";
import TableEmpresaSupervisora from "./Table";
import { ToastContainer } from "react-toastify";


export const EmpresasSupervisoras = () => {

    return (
        <>
            <ToastContainer />

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <Breadcrumbs
                            title={'Empresas Supervisoras'}
                            nameFirst={'Configuración'}
                            urlFirst={'/'}
                        />

                        <BuscarEmpresaSupervisora />
                        <TableEmpresaSupervisora />

                    </div>
                </div >
            </div >
        </>
    )
}
